<template>
  <div v-if="isExistSoftVersion">
    <v-menu
      open-on-hover
      offset-y
      :close-on-content-click="false"
      :open-on-click="false"
      :close-delay="200"
      max-width="380"
      z-index="110"
      :nudge-left="(380 - 28) / 2"
      nudge-top="8"
      transition="fade-transition"
      content-class="soft-version-icon-tooltip"
    >
      <template #activator="{ on, attrs }">
        <span
          v-bind="attrs"
          class="soft-version-icon__trigger cursor-pointer"
          data-qa="soft_version_icon"
          v-on="on"
        >
          <SoftVersionImage :image="softData.image" />
        </span>
      </template>

      <div class="d-flex flex-column ga-4">
        <div class="text-subtitle-1 text--text">
          {{ tStatic('Пользуется порталом с версией') }} {{ softData.translate }}
        </div>
        <div class="text-body-1 text--text d-flex flex-column ga-3">
          <div
            v-for="benefit in listBenefits"
            :key="benefit"
          >
            {{ getFirstLetterUpper(tStatic(benefit)) }}
          </div>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import getFirstLetterUpper from 'common/utils/getFirstLetterUpper'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import SoftVersionImage from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/components/common/SoftVersionImage.vue'
import { getListBenefits } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/functions'
import { SOFT_VERSION, SOFT_VERSION_DATA } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/constants'

const props = defineProps<{
  softVersion: string
  isLpuPage: boolean
}>()

const isExistSoftVersion = computed(() => (
  Object.values(SOFT_VERSION).includes(props.softVersion)
))

const listBenefits = computed(() => getListBenefits({
  softVersion: props.softVersion,
  isLpuPage: props.isLpuPage,
}))

const softData = computed(() => SOFT_VERSION_DATA[props.softVersion] || {})
</script>

<style lang="scss" scoped>
.soft-version-icon__trigger {
  position: absolute;
  top: 0;
  left: 0;
  width: 28px;
  height: 33px;
}
</style>

<style lang="scss">
@import 'src/styles/variables';

.soft-version-icon-tooltip {
  padding: 24px;
  user-select: text;
  box-shadow: 0 2px 24px 0 rgba(9, 42, 72, 0.08),
    0 0 2px 0 rgba(21, 40, 92, 0.06),
    0 1px 2px 0 rgba(5, 23, 40, 0.08);
  background-color: $ui-kit-bg-gray-0 !important;
  border-radius: $border-radius-xl;
}
</style>
